import type { ReadonlyDeep, SimplifyDeep } from 'type-fest';
import { z } from 'zod';

import { allowVariablePlaceholders } from './raw-variable-placeholder';

export type RawBillingConfig = SimplifyDeep<
  ReadonlyDeep<z.infer<typeof RawBillingConfigSchema>>
>;

export const createRawCostByResourceTypeSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      per_machine: z.number().nonnegative().optional(),
      binary_data_upload_bytes: z.number().nonnegative().optional(),
      binary_data_egress_bytes: z.number().nonnegative().optional(),
      binary_data_cloud_storage_bytes: z.number().nonnegative().optional(),
      tabular_data_upload_bytes: z.number().nonnegative().optional(),
      tabular_data_egress_bytes: z.number().nonnegative().optional(),
      tabular_data_cloud_storage_bytes: z.number().nonnegative().optional(),
      history_cloud_storage_bytes: z.number().nonnegative().optional(),
      logs_cloud_storage_bytes: z.number().nonnegative().optional(),
      logs_data_upload_bytes: z.number().nonnegative().optional(),
      logs_data_egress_bytes: z.number().nonnegative().optional(),
    }),
    allowVariables
  ).optional();
};

export const RawCostByResourceTypeSchema = createRawCostByResourceTypeSchema();

export const createRawBillingConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      cost_per_month:
        createRawCostByResourceTypeSchema(allowVariables).optional(),
      cost_per_year:
        createRawCostByResourceTypeSchema(allowVariables).optional(),
      tier_name: z.string().optional(),
      description: z.string().optional(),
      tier_credit: z.number().optional(),
      in_arrears: z.boolean().optional(),
      free_trial_duration_days: z.number().int().nonnegative().optional(),
    }),
    allowVariables
  ).passthrough();
};

export const RawBillingConfigSchema = createRawBillingConfigSchema();
